import '.d{display:flex;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'


import { labelAddressBuilder } from '@app/util/helpers'
import { SectionHeader } from '../../sectionHeader/SectionHeader'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { pages } from '@app/util/links'
import { RegionalListInitiativeModel } from 'functions/app/initiative/list-regional'
import { InitiativeCard } from '../../card/InitiativeCard'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { Title } from '@app/components/core/typography/Title'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type InitiativesContentSectionType = {
  type: 'initiatives'
  title: string
  titleLevel?: 'H1' | 'H2' | 'H3' | 'H4'
  seeMoreLabel?: string
  seeMoreLink?: string
  items: RegionalListInitiativeModel[]
}

export const InitiativesContentSection = ({
  title,
  titleLevel = 'H4',
  seeMoreLabel,
  seeMoreLink,
  items,
}: InitiativesContentSectionType) => {
  const t = useTranslations().app
  const isMobile = useMediaQuery()

  if (items.length === 0) return null

  return (
    <Column alignItems="stretch" gap={0}>
      <AppearItem staggerIndex={0}>
        {seeMoreLink ? (
          <SectionHeader
            title={title}
            titleLevel={titleLevel}
            seeMore={seeMoreLabel ?? t.common.seeMore}
            toRoute={seeMoreLink}
          />
        ) : (
          <Title.Hx title={titleLevel} style={{ marginBottom: '1rem' }}>
            {title}
          </Title.Hx>
        )}
      </AppearItem>
      <div className="d g"
        style={{
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        {items.map((initiative, index) => (
          <InitiativeCardItem
            key={initiative.slug}
            initiative={initiative}
            staggerIndex={index + 1}
          />
        ))}
      </div>
    </Column>
  )
}

const InitiativeCardItem = ({
  initiative,
  staggerIndex,
}: {
  initiative: RegionalListInitiativeModel
  staggerIndex: number
}) => {
  const t = useTranslations().app
  const appearStyle = useAppearStyle(staggerIndex)

  return (
    <InitiativeCard
      to={pages.initiative(initiative.slug)}
      image={initiative.images?.[0] ?? defaultProjectPicture}
      title={initiative.title}
      description={initiative.description}
      location={labelAddressBuilder(
        initiative.location?.address,
        t.common.notSpecified,
        'regional',
      )}
      phase={initiative.phase?.name}
      tagText={
        initiative.searchingForMembers
          ? t.common.initiativeStatus.searchingForMembers
          : t.common.initiativeStatus.notSearchingForMembers
      }
      tagVariant={initiative.searchingForMembers ? 'success' : 'neutral'}
      style={appearStyle}
    />
  )
}
